import { render, staticRenderFns } from "./HeroBanner.vue?vue&type=template&id=3dd12096&scoped=true&"
import script from "./HeroBanner.vue?vue&type=script&lang=js&"
export * from "./HeroBanner.vue?vue&type=script&lang=js&"
import style0 from "./HeroBanner.vue?vue&type=style&index=0&id=3dd12096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd12096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd12096')) {
      api.createRecord('3dd12096', component.options)
    } else {
      api.reload('3dd12096', component.options)
    }
    module.hot.accept("./HeroBanner.vue?vue&type=template&id=3dd12096&scoped=true&", function () {
      api.rerender('3dd12096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/HeroBanner.vue"
export default component.exports